import { useState } from 'react'
import { cover } from '../../utility/constant/helper.constant'
import {
  TAttachment,
  TDitchForm,
  TDockOpacity,
  TDockTile,
  TGlassDensity,
  TGlassOpacity,
  TSupportForm,
  TTerraceColor,
} from '../../utility/type/terraceCover.type'

/**
 * Values and methods are used by the context API
 * @returns states being used to manipulate the scene
 */

export const useStateRoof = () => {
  const [attachment, setAttachment] = useState(cover.terraceCover.attachment)
  const [userColor, setUserColor] = useState<TTerraceColor>(cover.bar.color)
  const [safetyGlass, setSafetyGlass] = useState<TGlassOpacity>(
    cover.terraceCover.safetyGlass
  )

  const [dockGlass, setDockGlass] = useState<TDockOpacity>(
    cover.terraceCover.dockGlass
  )
  const [ditchForm, setDitchForm] = useState<TDitchForm>(
    cover.terraceCover.ditchForm
  )

  const [supportForm, setSupportForm] = useState<TSupportForm>(
    cover.terraceCover.supportForm
  )

  const onHandleAttachment = (value: TAttachment) => {
    setAttachment(value)
  }

  /**
   * Sets the color of the terrace cover
   */
  const onHandleTerraceColor = (value: TTerraceColor) => {
    setUserColor(value)
  }

  const onHandleDitchForm = (value: TDitchForm) => {
    setDitchForm(value)
  }

  const onHandleSupportForm = (value: TSupportForm) => {
    setSupportForm(value)
  }

  /**
   * Sets the opacity of the window to display different safety glass types
   * @remark Opacity triggers a color change for the window
   */
  const onHandleSafetyGlass = (value: TGlassDensity) => {
    let opacity: TGlassOpacity = 0.3

    switch (value) {
      case '8 mm klar (VSG)':
        opacity = 0.3
        break
      case '8 mm opal (VSG)':
        opacity = 0.6
        break
      case '10 mm klar (VSG)':
        opacity = 0.5
        break
      case '10 mm opal (VSG)':
        opacity = 0.65
        break
      case '16 mm klar (Polycarbonat)':
        opacity = 0.5
        break
      case '16 mm opal (Polycarbonat)':
        opacity = 0.75
        break
      default:
        opacity = 0.3
    }

    setSafetyGlass(opacity)
  }

  const onHandleDockTile = (value: TDockTile) => {
    let opacity: TDockOpacity = 0.3

    switch (value) {
      case '16mm klar':
        opacity = 0.3
        break
      case '16mm opal':
        opacity = 0.4
        break
      default:
        opacity = 0.3
    }

    setDockGlass(opacity)
  }

  return {
    roof: {
      attachment,
      userColor,
      ditchForm,
      supportForm,
      safetyGlass,
      dockGlass,
    },

    roofMethod: {
      onHandleAttachment,
      onHandleTerraceColor,
      onHandleSafetyGlass,
      onHandleDockTile,
      onHandleDitchForm,
      onHandleSupportForm,
    },
  }
}
